import ScheduleSessionView from './ScheduleSessionView'
export default ScheduleSessionView
